/**
 * Google service — the member's Google OAuth tokens (`google_access_tokens`,
 * `google_refresh_tokens`), one pair per membership (person + org).
 */

import { revokeGoogleTokens } from "../gql/google.js"
import type { Mutate, Query } from "../index.js"

/** How many token rows a revoke deleted. */
export interface GoogleRevokeResult {
  accessTokens: number
  refreshTokens: number
}

export function createGoogleService({ mutate }: { query: Query; mutate: Mutate }) {
  /**
   * Delete the membership's Google tokens in one mutation. Runs as the
   * caller's default role (heavybit_staff), whose delete permission only
   * matches the caller's own rows: the session's org is ANDed on there, so
   * the caller passes no org id. The browser revokes with Google itself
   * first (useGoogle); this only forgets the tokens on our side.
   */
  const revoke = async ({ personId }: { personId: number }): Promise<GoogleRevokeResult> => {
    const data = await mutate(revokeGoogleTokens, { personId })
    return {
      accessTokens: data.delete_google_access_tokens?.affected_rows ?? 0,
      refreshTokens: data.delete_google_refresh_tokens?.affected_rows ?? 0,
    }
  }

  return { revoke }
}
